import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
    |--------------------------------------------------------------------------
    | projects Routes
    |--------------------------------------------------------------------------|
    */

    path: 'events',
    name: 'events',
    children: [
        {
            path: 'list',
            component: () => import('@/Modules/Events/views/events/Index.vue'),
            name: 'events-index',
            meta: {  requiresPermission: [abilities.CAN_VIEW_EVENT, abilities.CAN_VIEW_ALL_EVENT], requiresAccess: [moduleAbilities.EVENT_PORTAL]},
        },
        {
            path: ':id/view',
            component: () => import('@/Modules/Events/views/events/View.vue'),
            name: 'events-view',
            meta: {  requiresPermission: [abilities.CAN_VIEW_EVENT, abilities.CAN_VIEW_ALL_EVENT], requiresAccess: [moduleAbilities.EVENT_PORTAL]},
        },
        {
            path: ':id/set/:form/form',
            component: () => import('@/Modules/Events/views/questions/Update.vue'),
            name: 'events-form-update',
            meta: {  requiresPermission: [], requiresAccess: [moduleAbilities.EVENT_PORTAL]},
        },
        {
            path: '/events/:id/set/:form/preview',
            component: () => import('@/Modules/Events/views/questions/Preview.vue'),
            name: 'events-form-preview',
            meta: {  requiresPermission: [], requiresAccess: [moduleAbilities.EVENT_PORTAL]},
        },
        {
            path: 'events/:id/planning/:planning/view',
            component: () => import('@/Modules/Events/views/Planning/View.vue'),
            name: 'events-planning-view',
            meta: {  requiresPermission: [], requiresAccess: [moduleAbilities.EVENT_PORTAL]},
        },
        {
            path: 'settings-events',
            name: 'settings-events',
            component: () => import('@/Modules/Events/views/Setting/Layouts/BaseEventsSetting.vue'),
            meta: { requiresAccess: []},
            children: [
                {
                    name: "settings-events-status",
                    path: "status",
                    component: () => import('@/Modules/Events/views/Setting/ParticipatorStatus/Index.vue'),
                },
                {
                    name: "settings-events-mail-template",
                    path: "mail/templates",
                    component: () => import('@/Modules/Events/views/Setting/TemplateMail/Index.vue'),
                },
                {
                    name: "settings-events-template_key",
                    path: "templates/key",
                    component: () => import('@/Modules/Events/views/Setting/TemplateKey/Index.vue'),
                },
            ]
        },
        {
            path: 'event/:id/do/inscription',
            name: 'events-register', 
            component: () => import('@/Modules/Events/views/auth/AdminRegister.vue'),
        },
        
        {
            path: '',
            name: 'events-nps',
            component: () => import('@/Modules/Events/views/events/View.vue'),
            meta: { requiresAccess: []},
            children: [
                {
                    name: "events-nps-index",
                    path: ":id/view/nps/list",
                    component: () => import('@/Modules/Events/views/Nps/Index.vue'),
                },
                {
                    name: "events-nps-create",
                    path: ":id/view/nps/create",
                    component: () => import('@/Modules/Events/views/Nps/Create.vue'),
                },
                {
                    path: ':id/view/nps/:nps/preview',
                    component: () => import('@/Modules/Events/views/Nps/Preview.vue'),
                    name: 'events-nps-preview',
                    meta: {},
                },
                {
                    path: ":id/view/nps",
                    name: "events-nps-view",
                    component: () => import('@/Modules/Events/views/Nps/Layouts/NpsViewLayout.vue'),
                    meta: {  requiresPermission: abilities.VIEW_NPS,requiresAccess: [moduleAbilities.CUSTOMER_NPS]},
                    children:[
                        {
                            path: ':nps/details',
                            component: () => import('@/Modules/Events/views/Nps/View.vue'),
                            name: 'events-nps-details',
                            meta: {},
                        },
                        {
                            path: ':nps/responses',
                            component: () => import('@/Modules/Events/views/Nps/Responses.vue'),
                            name: 'events-nps-responses',
                            meta: {},
                        },
                        {
                            path: ':nps/responses/:response/details',
                            component: () => import('@/Modules/Events/views/Nps/ResponseOverview.vue'),
                            name: 'events-nps-responses-details',
                            meta: {},
                        },
                        {
                            path: ':nps/statistics',
                            component: () => import('@/Modules/Events/views/Nps/Statistics.vue'),
                            name: 'events-nps-statistics',
                            meta: {},
                        },
                    ]
                }
            ]
        },
    ]
}
